<template>
  <div class="v2-sales-analytics-filter">
    <v2-date-range-picker
      v-model="filterDate"
      placeholder="Select Date"
      :config="MONTH_CONFIG"
      @change="onDateChange"
    />
  </div>
</template>

<script>
import V2DateRangePicker from '@/components/v2/V2DateRangePicker.vue'
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect' // eslint-disable-line
import moment from 'moment'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'

const { KP_DATE_FORMAT } = c

const MONTH_CONFIG = {
  dateFormat: KP_DATE_FORMAT.DEFAULT,
  mode: 'single',
  plugins: [
    new MonthSelectPlugin({
      dateFormat: 'M Y',
      shorthand: true,
    }),
  ],
}

export default {
  name: 'V2SalesAnalyticsFilter',
  components: {
    V2DateRangePicker,
  },
  data() {
    return {
      filterDate: moment().format('MMM YYYY'),
      MONTH_CONFIG,
    }
  },
  methods: {
    onDateChange(dates) {
      if (!dates || !dates.length) return
      const selectedDate = moment(dates[0]).format('MMM YYYY')
      analytics.track(constants.TRACKS.ACTIONS.BRAND_APPLIES_DATE_FILTER_IN_SALES_INSIGHTS_PAGE, { selectedDate })
      this.$emit('filter-by-date', selectedDate)
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-sales-analytics-filter {
  max-width: 200px;
}
</style>
